export const externalInventoryDefaultConfigs = [
  {
    id: 'SKU',
    mappedId: 'sku',
    width: 200,
    pinned: false,
    index: 0,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'ConnectionName',
    mappedId: 'connectionName',
    width: 200,
    pinned: false,
    index: 1,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'ConnectionSKU',
    mappedId: 'connectionSku',
    width: 200,
    pinned: false,
    index: 2,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'ProductName',
    mappedId: 'productName',
    width: 200,
    pinned: false,
    index: 3,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'Available',
    mappedId: 'available',
    width: 100,
    pinned: false,
    index: 4,
    minWidth: 70,
    nonsortable: true,
  },
];
